import { ResponsibilityRoleMapping } from './ResponsibilityRoleMapping'
import nameof from 'ts-nameof.macro';
import { ObjectField,  } from 'react3l-decorators';

import { Responsibility } from 'models/Responsibility';
import { Role } from 'models/Role';

ObjectField(Responsibility)(ResponsibilityRoleMapping.prototype, nameof(ResponsibilityRoleMapping.prototype.responsibility));
ObjectField(Role)(ResponsibilityRoleMapping.prototype, nameof(ResponsibilityRoleMapping.prototype.role));

export * from './ResponsibilityRoleMapping';
export * from './ResponsibilityRoleMappingFilter';
